export default "__VITE_ASSET__CqnJltOh__"